import { createStore } from 'vuex'
import axios from '@/plugins/axios';
import Toast from "@/plugins/toast";
import Swal from "sweetalert2";
import {useFavicon} from "@vueuse/core";


export default createStore({
  state: {
    siteName:'بازاریابی',
    user:{
      'name':localStorage.getItem('name'),
      'id':localStorage.getItem('id'),
      'token':localStorage.getItem('token'),
      'access':localStorage.getItem('access'),
      'avatar':localStorage.getItem('avatar'),
      'status':localStorage.getItem('status'),
      'allowed_to_watch':localStorage.getItem('allowed_to_watch'),
      'role':localStorage.getItem('role'),
      'agree_contract':localStorage.getItem('agree_contract'),
    },
    // api:'http://localhost:8000/api/',
    // url:'http://localhost:8000',
    api:'https://app.o2n.ir/api/',
    url:'https://app.o2n.ir',
    errors:[],
    siteConfig:null,
    cooperationDiscount:50,
    basketData:[],
    basketCount:0,
    basketKey:0,
    fullAmount:0,
    toggleAside:false,
    showBasektPoup:false,
    showNav:false,
    asideTab:1,
    basketFullAmount:0,
    basketAmount:0,
    basketDiscount: 0,
    basketDiscountPercent:0,
    productFullWeight:0,
    packageInfo:[],
    searchText:'',
    addressComponentKey:0,
    validationErrorModal:false,
    current:1,
    previous:"",
    next:null,
    imageSize:'1 مگابایت',
    oneMgByte: 1024,
    total:1,
    valueAdded:9,
    permissions:[],
    userPermissions:[],
  },
  mutations: {
    paginate(state, {current_page, to, per_page, last_page}){
      state.current = current_page;
      state.next = to;
      state.previous = per_page;
      state.total = last_page;
    },

    handleError(state,payload){
      const response = payload.response;
      console.log(response)
      if(response === undefined || response.status === 500){
        if(response !== undefined){
          let msg = response.data.msg;
          if(msg){
            Toast.error(msg)
          }else{
            Toast.error('یک خطای غیر منتظره رخ داده است')
          }
        }else{
          Toast.error('یک خطای غیر منتظره رخ داده است')
        }
      }else if(response.status === 422){
        state.errors = Object.values(response.data.errors)
        state.validationErrorModal = true;
      }else if(response.status === 413) {
        Toast.error('یک خطای غیر منتظره رخ داده است')
      }else if(response.status === 403 || response.status === 401){
        // window.location.href = `/error/${response.status}/دسترسی شما غیر مجاز است برای بررسی بیشتر با ما تماس بگیرید`;
      }else if(response.status === 404){
        // window.location.href = `/error/${response.status}/ صفحه مورد پیدا نشد`;
      }
    },

    async setStorage(state, payload){
      const setToken = payload[0]
      const userData = payload[1]
      localStorage.setItem('name',userData.name);
      localStorage.setItem('id',userData.id);
      localStorage.setItem('avatar',userData.avatar);
      localStorage.setItem('allowed_to_watch',userData.allowed_to_watch);
      localStorage.setItem('access',userData.access);
      localStorage.setItem('status',userData.status);
      localStorage.setItem('role',userData.role);
      localStorage.setItem('agree_contract',userData.agree_contract);
      state.user.name = userData.name;
      state.user.id = userData.id;
      state.user.allowed_to_watch = userData.allowed_to_watch;
      state.user.avatar = userData.avatar;
      state.user.access = userData.access;
      state.user.role = userData.role;
      state.user.status = userData.status;
      state.user.agree_contract = userData.agree_contract;

      if(setToken){
        localStorage.setItem('token',userData.token)
        state.user.token = userData.token;
      }

      await this.dispatch('setCookie', 'expire_token');

    },
    clearStorage(state){
      document.cookie = 'expire_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      state.user.name = null;
      state.user.id = null;
      state.user.avatar = null;
      state.user.allowed_to_watch = null;
      state.user.access = null;
      state.user.status = null;
      state.user.role = null;
      state.user.token = null;
      state.user.agree_contract = null;
      const uuid = localStorage.getItem('basket_uuid')
      localStorage.clear()
      localStorage.setItem('basket_uuid',uuid === null ? '' : uuid)
    },
    setBasketInfo(state,payload){
      let basket = payload.basket;
      state.basketCount = basket.basket_count;
      state.fullAmount = basket.full_amount
      state.basketDiscountPercent = basket.basket_discount_percent
      state.basketDiscount = basket.basket_discount 
      state.basketFullAmount = basket.basket_full_amount
      state.basketAmount = basket.basket_amount
      state.basketData = basket.data ?? []
      state.packageInfo = basket.package_info
      state.productFullWeight = basket.product_full_weight
      localStorage.setItem('basket_uuid',payload.uuid === null ? '' : payload.uuid);
    },
    emptyBasketData(state){
      state.basketCount = 0;
      state.fullAmount = 0
      state.basketFullAmount = 0
      state.basketAmount = 0
      state.basketDiscountPercent = 0
      state.basketDiscount = 0
      state.basketData = []
      state.packageInfo = []
      state.productFullWeight = 0
    },
    emptyBasket(state){
      state.basketCount = 0;
      state.fullAmount = 0
      state.basketFullAmount = 0
      state.basketAmount = 0
      state.basketDiscountPercent = 0
      state.basketDiscount = 0
      state.basketData = []
      state.packageInfo = []
      state.productFullWeight = 0
      localStorage.removeItem('basket_uuid');
    }
  },
  actions: {
    setFavicon({state}, favicon){
      const icon = useFavicon()
      icon.value = favicon
    },
    async setCookie({state},name) {
      let expires = "";
      let date = new Date();
      let timestamp = date.setTime(date.getTime() + (24*60*60*100));
      expires = "; expires=" + date.toUTCString();
      document.cookie = name + "=" + timestamp  + expires + "; path=/";
    },

    async addOrSubBasket({state,commit},{isAdd,slug,count,uuid,isReplaceCount=false}){
      uuid === null ? '' : uuid;
      await axios.post(`${state.api}add-or-sub-basket/${slug}`,{is_add:isAdd,count:count,uuid:uuid,is_replace_count:isReplaceCount}).then(async resp=>{
        commit('setBasketInfo',resp.data.data);
        Toast.success('با موفقیت به سبد خرید اضافه شد')
      }).catch(err=>{
        commit('handleError',err)
      })
      state.basketKey ++
    },

    async deleteBasket({state,commit},{slug,uuid}){
      uuid === null ? '' : uuid;
      await axios.post(`${state.api}delete-basket/${slug}`,{uuid:uuid}).then(async resp=>{
        commit('setBasketInfo',resp.data.data);
        Toast.success('با موفقیت به سبد خرید حذف شد')
      }).catch(err=>{
        commit('handleError',err)
      })
    },

    async getBasket({state,commit},{uuid}){
      uuid === null ? '' : uuid;
      await axios.get(`${state.api}get-basket/${uuid}`).then(async resp=>{
        commit("emptyBasketData");
        commit('setBasketInfo',resp.data.data);
      }).catch(err=>{
        commit('clearStorage')
      })
    },

    async deleteRecord({commit,state},payload){
      await Swal.fire({
        title: "آیا از حذف این ایتم مطمئنید؟",
        text: payload[1],
        icon: "warning",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'بله',
        denyButtonText: `خیر`,

      }).then((willDelete) => {
        if (willDelete.isConfirmed) {
          state.isLoading  = true;
          axios.delete(state.api+payload[0]).then(resp=>{
            if(resp.data.status === 'success'){
              Swal.fire({
                title:'ایتم مورد نظر با موفقیت حذف شد',
                icon: "success",
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `بستن`,
              });
            }else {
              Swal.fire({
                title:'حذف با خطا مواجه شد.',
                icon: "error",
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `بستن`,
              });
            }
          }).catch(err=>{
            state.isLoading = false;
            commit('handleError',err)
          })
        }
      });
    },

    async sleep({state},payload=700) {
      await new Promise(resolve => setTimeout(resolve, payload));
    },

    checkToken({state,commit}){
      axios.get(`${state.api}check-token`).then(resp=>{
        const data = resp.data.data;
        if(data.token_valid){
          if(data.status === 'no'){
            commit('clearStorage')
            window.location.href = '/error/403/دسترسی شما غیر فعال میباشد برای بررسی بیشتر با ما تماس بگیرید'
          }else{
            state.userPermissions = data.permissions;
            commit('setStorage',[false,data])
          }
        }else{
          commit('clearStorage')
        }
      }).catch(err=>{
        commit('clearStorage')
      })
    },
  },
  getters: {
    numberFormat:(state)=>(number)=>{
      return new Intl.NumberFormat().format(number);
    },

    dateToPersian:(state)=>(date)=>{
      return new Date(date).toLocaleDateString('fa-IR-u-nu-latn');
    },

    capitalizeFirstLetter:(state)=>(string)=>{
      return string && string[0].toUpperCase() + string.slice(1);
    },

    getPrice:(state)=>(product)=>{
      if(state.user.token !== null && state.user.access === 'agent'){
        return product.agent_price
      }else{
        return product.price
      }
    },

    getValueAdded:(state, getters)=>(product, isAllData=true, _valueAdded=0)=>{
      let price = isAllData ? getters.getPrice(product) : parseInt(product);
      let value_added = _valueAdded === 0 ? state.valueAdded : _valueAdded

      return price + ((price * value_added) / 100);
    },


    priceToToman:(state)=>(input)=>{
      let x = input.value;
      let price = x.split(',').join('')
      $('#amount_toman').html(new Intl.NumberFormat().format((price/10).toString()) + ' تومان ')
      x = x.replace(/,/g, ""); // Strip out all commas
      x = x.reverse();
      x = x.replace(/.../g, function (e) {
        return e + ",";
      }); // Insert new commas
      x = x.reverse();
      x = x.replace(/^,/, ""); // Remove leading comma
      input.value = x;
    },

    getDiscount:(state,getters)=>(price, discount, numberFormat=true)=>{
      price = parseInt(price)

      price = price - ((parseInt(discount) / 100) * price);

      return numberFormat ? getters.numberFormat(price) : price;
    },
    getToken(state){
      return state.user.token;
    },
    getErrors(state){
      return state.errors;
    },
    getCookie: (state) => (name) => {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) {
          return c.substring(nameEQ.length,c.length)
        }
      }
      return null;
    },
    userCan: (state) => (permission,filter='') => {
      if(state.user.access === 'admin'){
        if(filter === 'include'){
          return state.userPermissions.filter(item=>item.includes(permission)).length > 0
        }else{
          return state.userPermissions.filter(item=>item === permission).length > 0
        }
      }else{
        return true;
      }
    },

    readTime:(state)=>(content)=>{
      if(content !== null && content.length > 0){
        const words = content.split(' ');
        let timeForRead = Math.trunc((words.length * 0.12) / 60);
        return timeForRead === 0 ? 'کمتر از 1 دقیقه' : timeForRead + ' دقیقه '
      }else{
        return "کمتر از 1 دقیقه"
      }
    },

  }
})
